import { giphyLightGrey } from '@giphy/js-brand'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CreationToolUploadContext } from '../manager'
import { CreationToolUploadSource } from '../types'
import { CheckIcon, ErrorIcon } from './icons'
import Item from './item'

const Bucket = styled.div`
    margin-bottom: 30px;

    &:last-child {
        margin-bottom: 0;
    }
`

const Header = styled.div`
    align-items: center;
    color: ${giphyLightGrey};
    display: flex;
    font-size: 15px;
    font-weight: bold;
    height: 36px;
    line-height: 1;
    width: 100%;

    svg {
        display: block;
        height: 16px;
        margin-right: 8px;
    }

    span {
        color: #fff;
        display: inline-block;
        margin-left: 8px;
    }
`

const CreationUploadListBulk = () => {
    const { uploadSources } = useContext(CreationToolUploadContext)
    const [errorSources, setErrorSources] = useState<CreationToolUploadSource[]>([])
    const [readySources, setReadySources] = useState<CreationToolUploadSource[]>([])

    // separate sources into ones with errors and ones without
    useEffect(() => {
        setErrorSources(uploadSources.filter(source => !!source.error))
        setReadySources(uploadSources.filter(source => !source.error))
    }, [uploadSources])

    return (
        <>
            <Bucket>
                {errorSources.length > 0 && (
                    <Header>
                        <CheckIcon />
                        Ready for Upload
                        <span>{readySources.length}</span>
                    </Header>
                )}
                {readySources.map((source, i) => (
                    <Item key={source.id} source={source} isPreviewingByDefault={i === 0 || source.isDuplicate} />
                ))}
            </Bucket>
            {errorSources.length > 0 && (
                <Bucket>
                    <Header>
                        <ErrorIcon />
                        Fix Errors to Upload
                        <span>{errorSources.length}</span>
                    </Header>
                    {errorSources.map(source => (
                        <Item key={source.id} source={source} />
                    ))}
                </Bucket>
            )}
        </>
    )
}

export default CreationUploadListBulk
